import {ConditionSignalTypeName} from 'common/src/modules/excelToCampaign/excelToCampaign.enums';
import {z} from 'zod';
import {columnToSignalMappingSchema} from '../../excelToCampaignAgent.schemas';

const excelColumnSchema = z.object({
  headerName: z.string(),
  columnIndex: z.number(),
  columnValuesType: z.nativeEnum(ConditionSignalTypeName),
  uniqueValues: z.array(z.string()),
});

const mappingScoreSchema = z.object({
  score: z.number().describe('Mapping score on a scale of 0-100'),
  nameMatchScore: z.number().describe('Score for name matching (0-50)'),
  typeCompatibilityScore: z.number().describe('Score for type compatibility (0-30)'),
  formatMatchScore: z.number().describe('Score for format matching (0-20)'),
});

// Extend the columnToSignalMappingSchema to include scoring
const scoredColumnToSignalMappingSchema = columnToSignalMappingSchema.extend({
  scoring: mappingScoreSchema.describe('Scoring details for this mapping candidate'),
});

const findMappingCandidatesResponseSchema = z.object({
  mappingCandidates: z.array(scoredColumnToSignalMappingSchema),
  nonCandidates: z
    .array(
      z.object({
        header: z.object({
          name: z.string().describe('The excel header name'),
          columnIndex: z.number().describe('The index of the column in the excel file'),
        }),
        reason: z.string().describe('The reason this header is not a candidate for any signal'),
      }),
    )
    .describe('Excel headers that are not candidates for any signal'),
});

export {
  findMappingCandidatesResponseSchema,
  excelColumnSchema,
  mappingScoreSchema,
  scoredColumnToSignalMappingSchema,
};
